export default __webpack_public_path__ + "static/media/tn.bd942715.svg";